




























































import {Vue, Component} from "vue-property-decorator";
import Table from "@/model/table";
import Language from "@/common/language";
import staffCallApi from '@/api/staffCallApi';
import {namespace} from "vuex-class";
import { Setting } from "@/model/menuSetting";

const menuStore = namespace("MenuStore");
const tableStore = namespace("TableStore");

@Component({
  name: "QHeader",
})
export default class QHeader extends Vue {
  public isChangeLanguage = false;
  public isCall = false;
  public lang = 'ja';
  private appVersion = Language.appVersion;

  @tableStore.Getter
  getTable!: Table;
  @menuStore.Getter
  isShowStaffCall!: boolean;
  @menuStore.Getter
  getMenuSetting!: Setting;

  get titlePage(): string {
    return this.$t(this.$route.meta.title).toString() + ' ' + this.tableNo + this.$t('卓') || "";
  }
  get subTitle(): string {
    return this.$t(this.$route.meta.subTitle).toString() + ' ' + this.tableNo + this.$t('卓')  || "";
  }

  created() {
    this.lang = Language.getLang();
    if (!this.lang) {
      this.lang = "日本語";
      this.changeLanguage();
      this.isChangeLanguage = false;
    }
  }

  get tableNo (): number {
    return this.getTable.getTableNo()
  }

  public changeLanguage() {
    Language.setLang(this.lang);
    this.isChangeLanguage = !this.isChangeLanguage;
    this.$i18n.locale = this.lang;
  }

  public showLanguage() {
    this.isChangeLanguage = !this.isChangeLanguage;
  }

  public async call() {
    const response = await staffCallApi.store();
    if (!response) {
      return;
    }
    if (response.status === 200 && response.data.code === 200200200) {
      this.isCall = true;
      await this.sleep(5 * 1000);
      this.isCall = false;
    }
  }

  async sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  isLangView (lang: 'en' | 'cn' | 'kr'): boolean {
    const setting = this.getMenuSetting;

    switch (lang) {
    case 'en':
      console.log(setting.languageEn);
      return setting.languageEn === '1';
    case 'cn':
      return setting.languageCn === '1';
    case 'kr':
      return setting.languageKr === '1';
    }
  }

  isLangSelector (): boolean {
    const setting = this.getMenuSetting;
    if (! setting) {
      return false;
    }

    return setting.languageEn === '1'
     || setting.languageCn === '1'
     || setting.languageKr === '1';
  }
}
